export default {
  findFunction: (query: string) => (i: any) =>
    i.text.toLowerCase().includes(query.toLowerCase().trim()),
  renderItem: (
    { text }: { text: string },
    { query, isHighlighted }: { query: string; isHighlighted?: boolean },
  ) => (
    <span data-query={query} data-h={isHighlighted}>
      {text}
    </span>
  ),
};
